const sortOptions = [
  {
    value: 'departmentName',
    name: 'global.department'
  },
  {
    value: 'orderType',
    name: 'global.orderType'
  },
  {
    value: 'createdBy',
    name: 'global.createdBy'
  },
  {
    value: 'modifiedAt',
    name: 'openCarts.table.datePlaced'
  },
  {
    value: 'totalWholesale',
    name: 'global.total'
  }
];

export { sortOptions };
